var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIconColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.646 14.354a.5.5 0 0 0 .708-.708l-.708.708zm-2.192-3.608a.5.5 0 0 0-.708.708l.708-.708zm.713-3.413a4.833 4.833 0 0 1-4.834 4.834v1a5.833 5.833 0 0 0 5.834-5.834h-1zm-4.834 4.834A4.833 4.833 0 0 1 2.5 7.333h-1a5.833 5.833 0 0 0 5.833 5.834v-1zM2.5 7.333A4.833 4.833 0 0 1 7.333 2.5v-1A5.833 5.833 0 0 0 1.5 7.333h1zM7.333 2.5a4.833 4.833 0 0 1 4.834 4.833h1A5.833 5.833 0 0 0 7.333 1.5v1zm7.02 11.146-2.9-2.9-.707.708 2.9 2.9.708-.708z",
    fill: "#500D76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconColored);
export default __webpack_public_path__ + "static/media/searchIconColored.65437953bcf8fbd6619a9b90df078661.svg";
export { ForwardRef as ReactComponent };